import React from 'react';
import PropTypes from 'prop-types';
import InboxMessageProp from '../../../../../sections/inbox/propTypes/inboxMessageProp';
import {
  INBOX_MSG_TYPE,
  TROPHY_CONFIG,
} from '../../../../../services/utilityFunctions';
import ReceiptNotificationIcon from '../../../../icons/ReceiptNotificationIcon';

export default function NotificationIcon({ notification }) {
  const { type, target, trophy } = notification;

  const userImage = target?.image?.thumb || '/images/no_user.png';

  switch (type) {
    case INBOX_MSG_TYPE.RATING:
    case INBOX_MSG_TYPE.LIKE:
    case INBOX_MSG_TYPE.COMMENT:
    case INBOX_MSG_TYPE.NEW_TIP:
    case INBOX_MSG_TYPE.HAPPY_BIRTHDAY:
    case INBOX_MSG_TYPE.REFERRAL_ORDER:
    case INBOX_MSG_TYPE.REFERRAL_LEVEL_UPDATED:
      return (
        <img
          src={userImage || '/images/no_user.png'}
          alt="user"
          className="notification-list-item-image"
        />
      );
    case INBOX_MSG_TYPE.OPPORTUNITY_NOTE:
    case INBOX_MSG_TYPE.OPPORTUNITY_DOCUMENT:
    case INBOX_MSG_TYPE.OPPORTUNITY_STATUS: {
      return (
        <img
          src={userImage}
          alt="user"
          className="notification-list-item-image"
        />
      );
    }
    case INBOX_MSG_TYPE.USER_INVITED_CREATED: {
      const ownerImage =
        userImage || '/images/notifications/UserInvitationIcon.svg';
      return (
        <img
          src={ownerImage}
          alt="user"
          className="notification-list-item-image"
        />
      );
    }
    case INBOX_MSG_TYPE.CHAT_JOINED:
      return (
        <img
          src={userImage || '/images/notifications/ChatJoinIcon.svg'}
          alt="user"
          className="notification-list-item-image"
        />
      );
    case INBOX_MSG_TYPE.TROPHY: {
      if (target) {
        return (
          <img
            src={userImage || '/images/no_user.png'}
            alt="user"
            className="notification-list-item-image"
          />
        );
      }

      let image;
      if (trophy.type === 'custom' && trophy.trophyCustom) {
        image = trophy.trophyCustom.icon?.url || trophy.trophyCustom.icon;
      } else if (trophy && TROPHY_CONFIG[trophy.type]) {
        image = TROPHY_CONFIG[trophy.type].imageURL;
      }
      return (
        <img
          src={
            image.length > 0 ? image : '/images/notifications/TrophyIcon.svg'
          }
          alt="trophy"
          className="notification-list-item-image"
        />
      );
    }
    case INBOX_MSG_TYPE.GAME_START:
    case INBOX_MSG_TYPE.GAME_END:
      return (
        <img
          src="/images/notifications/ChallengeIcon.svg"
          alt="challenge"
          className="notification-list-item-image"
        />
      );
    case INBOX_MSG_TYPE.COURSE_PENDING:
    case INBOX_MSG_TYPE.COURSES_NOT_TAKEN:
    case INBOX_MSG_TYPE.FIRST_COURSE:
      return (
        <img
          src="/images/notifications/CourseIcon.svg"
          alt="course"
          className="notification-list-item-image"
        />
      );
    case INBOX_MSG_TYPE.CHARITY_REPORT:
      return (
        <img
          src="/images/notifications/CharityIcon.svg"
          alt="charity"
          className="notification-list-item-image"
        />
      );
    case INBOX_MSG_TYPE.UNLOCK_REWARD:
    case INBOX_MSG_TYPE.SURVEY_REWARDS:
    case INBOX_MSG_TYPE.COURSE_REWARDS:
      return (
        <img
          src="/images/notifications/CoinsIcon.svg"
          alt="coins"
          className="notification-list-item-image"
        />
      );
    case INBOX_MSG_TYPE.ACCESS_SESSION:
      return (
        <img
          src="/images/notifications/SessionIcon.svg"
          alt="session"
          className="notification-list-item-image"
        />
      );
    case INBOX_MSG_TYPE.WALLET_WITHDRAW_APPROVED:
      return <ReceiptNotificationIcon />;
    default:
      return null;
  }
}

NotificationIcon.propTypes = {
  notification: PropTypes.shape(InboxMessageProp.propTypes).isRequired,
};
